var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"evenodd","d":"M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24zm23.281-4.492l.05.83-.839-.102c-3.055-.39-5.724-1.711-7.99-3.932l-1.109-1.101-.285.813c-.604 1.814-.218 3.729 1.04 5.017.672.712.521.813-.637.39-.403-.136-.756-.238-.79-.187-.117.119.286 1.661.605 2.271.437.848 1.326 1.678 2.3 2.17l.823.39-.974.016c-.94 0-.974.017-.873.373.336 1.102 1.662 2.271 3.14 2.78l1.04.356-.906.542a9.452 9.452 0 0 1-4.5 1.254c-.755.017-1.376.085-1.376.136 0 .17 2.048 1.118 3.24 1.491 3.576 1.102 7.823.627 11.013-1.254 2.266-1.339 4.532-4 5.59-6.576.57-1.373 1.141-3.881 1.141-5.084 0-.78.05-.882.99-1.814.555-.542 1.075-1.135 1.176-1.305.168-.322.151-.322-.705-.034-1.427.509-1.628.441-.923-.322.52-.542 1.141-1.525 1.141-1.813 0-.051-.252.034-.537.186-.302.17-.974.424-1.477.577l-.907.288-.822-.56c-.454-.305-1.092-.644-1.427-.745-.857-.238-2.166-.204-2.938.067-2.099.763-3.425 2.73-3.274 4.882z"}));
}

Twitter.displayName = "Twitter";

Twitter.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = Twitter;

Twitter.default = Twitter;



//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/twitter.svg
// module id = 1093
// module chunks = 22